import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhatsNew from "@/components/WhatsNew";
import MarqueeStrip from "@/components/MarqueeStrip";
import Features from "@/components/Features";
import Toolkit from "@/components/Toolkit";
import UseCases from "@/components/UseCases";
import SmartTools from "@/components/SmartTools";
import Trust from "@/components/Trust";
import FAQ from "@/components/FAQ";
import Pricing from "@/components/Pricing";
import StayInLoopCta from "@/components/StayInLoopCta";
import Footer from "@/components/Footer";
import { trackPageView } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    document.title = "Stable-ish — AI clinical reference for ER & ICU nurses.";
    trackPageView("landing");
  }, []);

  return (
    <main className="bg-[#050505] text-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <Hero />
      <WhatsNew />
      <MarqueeStrip />
      <Features />
      <Toolkit />
      <UseCases />
      <SmartTools />
      <Pricing />
      <Trust />
      <FAQ />
      <StayInLoopCta />
      <Footer />
    </main>
  );
}
